import { StorageGetNextListPage, StorageListPage } from '../common/list-page';
import { GoogleDriveItem } from './google-drive.item';

export class GoogleDriveListPage implements StorageListPage {
  constructor(
    private readonly storage: StorageGetNextListPage,
    private readonly req: Record<string, unknown>,
    private readonly fileList: gapi.client.drive.FileList,
    private readonly onlyFolders: boolean,
  ) {}

  public getItems(): GoogleDriveItem[] {
    return (this.fileList.files ?? []).map((file) => new GoogleDriveItem(file));
  }

  public hasNext(): boolean {
    return typeof this.fileList.nextPageToken !== 'undefined';
  }

  public async getNext(): Promise<StorageListPage> {
    if (!this.hasNext()) {
      throw new Error('Next page requested for the last page.');
    }

    return this.storage.getNextFolderPage(this.onlyFolders, {
      req: this.req,
      pageToken: this.fileList.nextPageToken,
    });
  }
}
